import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { ButtonClean, Icon } from '@fourthwall/components'
import { CloseIcon, QuestionIcon, TickIcon } from '@fourthwall/icons'

import * as S from './AccordionHeading.styled'
import type { Status } from './AccordionHeading.types'

export type AccordionHeadingProps = {
  status: Status
  label: string
  onSeeDetails?: () => void
}

const getIconComponent = (status: Status) => {
  const icons: Record<Status, IconComponent> = {
    approved: TickIcon,
    pending: QuestionIcon,
    rejected: CloseIcon,
  }

  return icons[status]
}

export const AccordionHeading = ({ status, label, onSeeDetails }: AccordionHeadingProps) => (
  <S.Container>
    <S.IconContainer>
      <S.Icon status={status}>
        <Icon component={getIconComponent(status)} height={10} />
      </S.Icon>
    </S.IconContainer>
    <S.Label>{label}</S.Label>
    {onSeeDetails && (
      <S.ButtonContainer>
        <ButtonClean label="See details" onClick={onSeeDetails} />
      </S.ButtonContainer>
    )}
  </S.Container>
)
